import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { setButtonBackToActive } from "@/store/tradeDataStoreACTIONS";
import {
  actionsConfigOP,
  actionsConfigRP,
  getEnumKeyByEnumValue,
  IActionObj,
} from "../actionButtonsHelper";
import { isActionAllowedByFills } from "../fillStateHelpers";

export const getActionsMainButton = (
  structureType: string,
  status: string,
  params: any,
  trade: any = params.data,
) => {
  const keyToPass = getEnumKeyByEnumValue(
    // Reverse map the string back to the enum.
    ExecutionStrategyStatus,
    status,
  );

  const viewTrade = [
    {
      id: "View Trade",
      function: () => {
        params.node.setExpanded(true);
        setButtonBackToActive(params.data.esid);
      },
    },
  ];

  // Early return to change the RP Exectued (Recoupen) actions:
  // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
  // if (
  //   params.node.data.role == "RP" &&
  //   keyToPass == "Executed" &&
  //   hasRecoupon(params)
  // ) {
  //   return [
  //     {
  //       id: "Recoupon",
  //       function: recouponTradeAction,
  //     },
  //   ];
  // }

  if (keyToPass && keyToPass != "New") {
    const actionsConfig =
      params.data.role == "OP" ? actionsConfigOP : actionsConfigRP;
    const configured = actionsConfig[structureType]?.[keyToPass];
    if (!configured) return viewTrade;

    // LQC-3249 - an Expired Order with no fills has nothing to close out.
    const allowed = configured.filter((action: IActionObj) =>
      isActionAllowedByFills(action.id, trade),
    );
    return allowed.length == 0 && configured.length > 0 ? viewTrade : allowed;
  } else if (status == "New") {
    return [
      {
        id: "Send to Panel", // Will be used to open a trade if it's closed. If open, this will attempt to send the trade.
        function: () => {
          params.node.setExpanded(true);
          setButtonBackToActive(params.data.esid);
        },
      },
    ];
  } else {
    return viewTrade;
  }
};
